import { lazy } from 'react';
import { LazyLoadWrapper, retry } from '~/components/ui/LazyLoadWrapper';
import { useStore } from '@nanostores/react';
import { supabaseStore } from '~/lib/stores/supabase';
import { userStore } from '~/lib/stores/user';
import { PrivateBetaScreen } from '~/components/dialogs/settings/project/PrivateBetaScreen';
import { NoDatabaseScreen } from './NoDatabaseScreen';

const DatabaseManagerContent = lazy(
  retry(() => import('~/components/ui/shadcn/components/supabase-manager/DatabaseManagerContent.client')),
);

export const DatabaseManagerView = () => {
  const supabaseStatus = useStore(supabaseStore.supabaseStatus);
  const featureFlags = useStore(userStore.featureFlags);
  const project = useStore(supabaseStore.supabaseProject);
  const projectId = project?.id;

  if (!featureFlags.supabaseManagement) {
    return (
      <PrivateBetaScreen
        icon="i-heroicons:circle-stack"
        title="Manage your app's data"
        className="pl-8 pr-6"
        description="Create tables, manage relationships, and configure your database schema directly from your project settings."
      />
    );
  }

  if (supabaseStatus !== 'CONFIGURED' || !projectId) {
    return <NoDatabaseScreen />;
  }

  return (
    <LazyLoadWrapper name="DatabaseManagerContent">
      <DatabaseManagerContent />
    </LazyLoadWrapper>
  );
};
